import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FacilityDocument, UploadFacilityDocument } from '../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FacilityDocumentsService {
  private http = inject(HttpClient);

  private baseUrl(id: string): string {
    return `/api/Facilities/${id}/documents`;
  }

  getAll(id: string): Observable<FacilityDocument[]> {
    return this.http.get<FacilityDocument[]>(`${this.baseUrl(id)}`);
  }

  create(
    id: string,
    payload: UploadFacilityDocument
  ): Observable<FacilityDocument> {
    return this.http.post<FacilityDocument>(`${this.baseUrl(id)}`, payload);
  }

  get(id: string, documentId: string): Observable<FacilityDocument> {
    return this.http.get<FacilityDocument>(`${this.baseUrl(id)}/${documentId}`);
  }

  delete(id: string, documentId: string): Observable<FacilityDocument> {
    return this.http.delete<FacilityDocument>(
      `${this.baseUrl(id)}/${documentId}`
    );
  }

  verify(id: string, documentId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl(id)}/${documentId}`, {});
  }

  download(id: string, documentId: string): Observable<void> {
    return this.http.get<void>(`${this.baseUrl(id)}/${documentId}`);
  }
}
